import { getScrollOffsetForHeader } from "./utils/layout";

declare const jQuery: any;
const $ = jQuery;
const linkSelector = "a[href*=\"#\"]";
const animDuration = 500;


export function init()
{
	$(linkSelector).each(function eachLink() {
		initLink($(this));
	});
}

function initLink($a): void
{
	const href = $.trim($a.attr("href"));
	const [url, id] = href.split(/\#/);
	if (!id)
	{
		return;
	}
	if (url && !urlIsForCurrentPage(url))
	{
		return;
	}
	$a.on("click", (e) => {
		if ($a.is(`[data-no-link-scroll]`)) {
			return;
		}
		const target = document.getElementById(id);
		if (target)
		{
			const scrollToConfig = {
				duration: animDuration,
				axis: "y",
				offset: {
					top: getScrollOffsetForHeader()
				}
			};
			$.scrollTo(target, scrollToConfig);
			e.preventDefault();
		}
	});
}

function urlIsForCurrentPage(url: string): boolean
{
	const currPath: string = window.location.pathname;
	return stripSlashes(currPath) === getPathFromUrl(url);
}

// no leading/trailing slashes returned
function getPathFromUrl(url: string): string
{
	let path = url.replace(/^https?\:\/\/[a-z0-9\-\.]\/+/gi, "");
	path = stripSlashes(path);
	return path;
}

function stripSlashes(s: string): string
{
	return s.replace(/(^\/+)|(\/+$)/g, "");
}
